export const globalEnv = {
	BASE_URL: process.env.REACT_APP_SERVER_URL,
	BUCKET_NAME:
		process.env.REACT_APP_AWS_S3_BUCKET_NAME || 'tabuland-statics-dev',

	DEBUG: true,
	LOG_LEVEL: ['log', 'warn', 'error']
};
